import React, { useState } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { Steps, Typography } from 'antd';
import { dateFromString } from '../../../utils/dateFromString';

const { Text } = Typography;

const PASOS = [
  { label: 'Calidad',        fechaKey: 'fechaAuthCalidad' },
  { label: 'Operaciones',    fechaKey: 'fechaAuthOperaciones' },
  { label: 'Dirección',      fechaKey: 'fechaAuthDireccion' },
  { label: 'Esperando Pago', fechaKey: null },
  { label: 'Pagado',         fechaKey: 'fechaPagado' },
];

export default function Flujo({ data }) {
  const [expandedItems, setExpandedItems] = useState({});
  const actual = (data?.estatusAuth ?? 1) - 1;
  const estaRechazado = data?.estatusAuth === 10;

  const toggleExpand = (index, e) => {
    e.stopPropagation();
    setExpandedItems(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
      <Steps direction="vertical" size="small" current={estaRechazado ? -1 : actual} style={{ flex: 1 }}>
        {PASOS.map((paso, index) => {
          const fecha = paso.fechaKey ? data?.[paso.fechaKey] : null;
          const isExpanded = expandedItems[index];

          const title = (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span>{paso.label}</span>
              {fecha && (
                <span onClick={(e) => toggleExpand(index, e)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <Text type="secondary">
                    {isExpanded ? <DownOutlined style={{ fontSize: '9px' }} /> : <RightOutlined style={{ fontSize: '9px' }} />}
                  </Text>
                </span>
              )}
            </div>
          );

          const description = fecha && isExpanded
            ? <Text type="secondary" style={{ fontSize: '10px' }}>{dateFromString(fecha)?.f1}</Text>
            : null;

          return (
            <Steps.Step
              key={paso.label}
              title={title}
              description={description}
            />
          );
        })}
      </Steps>
    </div>
  );
}
